module.exports = __webpack_public_path__ + "static/media/header.91ecaad3.jpg";